import { createContext, useContext } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { translations } from "@/data/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const params = useParams();
  const lang = params.lang === "en" ? "en" : "de";
  const location = useLocation();
  const navigate = useNavigate();

  const t = translations[lang];
  const lp = (p = "") => `/${lang}${p}`;
  const lf = (field) =>
    field && typeof field === "object" && !Array.isArray(field)
      ? field[lang] ?? field.de ?? ""
      : field;

  const switchTo = (target) => {
    if (target === lang) return;
    const rest = location.pathname.replace(/^\/(de|en)/, "");
    navigate(`/${target}${rest}${location.search}`);
  };

  return (
    <LanguageContext.Provider value={{ lang, t, lp, lf, switchTo }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
